// import PromotoinData from "../../../components/promotions/PromotoinData";
// import {PromotionCard} from "../../../components/cards/PromotionCard";

// export const Promotions = () => {
//     return (
//         <div className="container">
//             <div className="text-banner">
//                 <h1>Promotions</h1>
//             </div>
//             <section className="section-platforms" style={{background :"var(--bar_color)"}} data-aos={'fade-up'}>
//                 <div className="platforms-cards" style={{marginTop : 0}}>
//                     {
//                         PromotoinData.map((p, index) => {
//                             return (
//                                 <PromotionCard data={p} key={index} title={true}/>
//                             )
//                         })
//                     }
//                 </div>
//             </section>
//         </div>
//     )
// }
import './Promotions.css';
import { FaGift } from 'react-icons/fa'; // Make sure react-icons is installed

export const Promotions = () => {
    return (
        <div className="container">
            <div className="text-banner">
                <h1 className="promo-heading">Promotions</h1>
            </div>
            <section className="section-platforms1" data-aos="fade-up">
                <div className="coming-soon-wrapper">
                    <div className="gift-icon bounce">
                        <FaGift size={60} color="#00ffe5" />
                    </div>
                    <div className="coming-card">
                        <h2 className="glow-text">🎉 Exciting Promotions Are On Their Way!</h2>
                        <p className="coming-desc">
                            We're crafting special offers just for you — bonuses, discounts, surprises, and more!
                            Get ready to enjoy exclusive promotions tailored to boost your experience.
                        </p>
                        <div className="loader"></div>
                        <button className="notify-btn">🔔 Notify Me When Live</button>
                    </div>
                </div>
            </section>
        </div>
    );
};

